import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Stack = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5256 3.10407C11.8335 3.00144 12.1664 3.00144 12.4743 3.10407L20.6047 5.8142C21.7443 6.19407 21.7443 7.80603 20.6047 8.18591L12.4743 10.896C12.1664 10.9987 11.8335 10.9987 11.5256 10.896L3.39527 8.18591C2.25567 7.80604 2.25564 6.19408 3.39527 5.8142L11.5256 3.10407ZM6.16227 7.00005L12 8.94596L17.8377 7.00005L12 5.05415L6.16227 7.00005Z"
      fill="currentColor"
    />
    <path
      d="M11.5256 15.396L2.68376 12.4487L3.31622 10.5514L12 13.446L20.6838 10.5514L21.3162 12.4487L12.4743 15.396C12.1664 15.4987 11.8335 15.4987 11.5256 15.396Z"
      fill="currentColor"
    />
    <path
      d="M2.68376 16.9487L11.5256 19.896C11.8335 19.9987 12.1664 19.9987 12.4743 19.896L21.3162 16.9487L20.6838 15.0514L12 17.946L3.31622 15.0514L2.68376 16.9487Z"
      fill="currentColor"
    />
  </Icon>
));

export default Stack;
